import { ContactDialogProvider } from "@/components/ContactDialog";
import { SiteNav } from "@/components/SiteNav";
import { Hero } from "@/components/sections/Hero";
import { Foliage } from "@/components/sections/Foliage";
import { SoilLine } from "@/components/sections/SoilLine";
import { Root } from "@/components/sections/Root";
import { Harvest } from "@/components/sections/Harvest";
import { Footer } from "@/components/sections/Footer";
import { About } from "@/pages/About";
import { PrivacyPolicy } from "@/pages/PrivacyPolicy";
import { Team } from "@/pages/Team";

// The home page is a descent: above ground (Hero) -> the foliage (Foliage) ->
// the soil line (SoilLine) -> the root (Root, all product proof) -> back up
// into the harvest (Harvest + CTA). Backgrounds are static CSS gradients, so
// the "descent" is just native scrolling through them.
function Home() {
  return (
    <div className="min-h-screen">
      <SiteNav current="/" />
      <main>
        <Hero />
        <Foliage />
        <SoilLine />
        <Root />
        <Harvest />
      </main>
      <Footer />
    </div>
  );
}

export function App({ path }: { path: string }) {
  // Tiny path-based router. `path` is passed in so the component renders
  // identically on the server (pre-render in build.ts) and the client
  // (frontend.tsx reads window.location) — no window access during render.
  const clean = path.replace(/\/$/, "");

  let page: React.ReactNode;
  if (clean === "/privacy") page = <PrivacyPolicy />;
  else if (clean === "/team") page = <Team />;
  else if (clean === "/about") page = <About />;
  else page = <Home />;

  // One shared contact dialog for the whole app, so any page (home, about,
  // team) can open it via the reused CTA section.
  return <ContactDialogProvider>{page}</ContactDialogProvider>;
}

export default App;
